export const DOMAIN_FAVICON_MAP = {
  "retailer.goelectronix.com": "/favicons/goex.ico",
  "rrpvtltd.rrtechnolodgypvtltd.com": "/favicons/rr.ico",
};
